/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Invoice_AccrualInputs */

const cs_enum_invoice_accrual = /** @type {(inputs: Enum_Invoice_AccrualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připsání z faktury`)
};

const en_enum_invoice_accrual = /** @type {(inputs: Enum_Invoice_AccrualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice accrual`)
};

/**
* | output |
* | --- |
* | "Invoice accrual" |
*
* @param {Enum_Invoice_AccrualInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_invoice_accrual = /** @type {((inputs?: Enum_Invoice_AccrualInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Invoice_AccrualInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_invoice_accrual(inputs)
	return cs_enum_invoice_accrual(inputs)
});